export default "__VITE_ASSET__35605873__"